<div class="container-fluid">
	<div class="col-md-12" *ngIf="isLoading">
		<app-busy [message]="message"></app-busy>
	</div>
	<div class="page_header">
		<h1 class="heading">
			<i class="fa fa-cogs"></i>
			Manage {{this.lblHeading}}
		</h1>
	</div>

	<ng-template #content let-modal>
		<div class="modal-header">
			<h4 class="modal-title" id="modal-basic-title">Delete Confirmation</h4>
			<button type="button" class="btn-close" aria-label="Close"
				(click)="modal.dismiss('Cross click')">&times;</button>
		</div>
		<div class="modal-body">
			<input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
		</div>
		<div class="modal-footer">
			<button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
			<button class="btn btn-default btn-sm" (click)="modal.dismiss('Cross click')"
				style="width:80px;">No</button>
		</div>
	</ng-template>

	<div class="row">
		<div class="col-md-12" *ngIf="!isRemove">
			<app-actions (actionEvent)="doTransportAction($event)" [actions]="transportActions"></app-actions>
			<div class="table-responsive">
				<table id="vTypes" border="1" class="table tbl-stl custom_table">
					<thead class="thead-inverse hgt-btn">
						<tr class="hgt-btn">
							<th>Select</th>
							<th class="bfr-end-col">
								Code <i style="vertical-align:middle; " class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
									(click)="utility.onSort(1)"></i>
							</th>
							<th class="bfr-end-col">
								Description
								<i style="vertical-align:middle;" class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagDN == 2),'fa-sort-desc sort-d': (utility.flags.flagDN == 3), 'fa-sort':(utility.flags.flagDN == 1) }"
									(click)="utility.onSort(2)"></i>
							</th>
							<th style="vertical-align:middle;width:140px;" class="bfr-end-col">
								Active?
								<i style="vertical-align:middle;" class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagAE == 2),'fa-sort-desc sort-d': (utility.flags.flagAE == 3), 'fa-sort':(utility.flags.flagAE == 1) }"
									(click)="utility.onSort(3)"></i>
							</th>
							<th style="vertical-align:middle;width:140px;" class="bfr-end-col">
								Sort Order
								<i style="vertical-align:middle;" class="fa"
									[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagSO == 2),'fa-sort-desc sort-d': (utility.flags.flagSO == 3), 'fa-sort':(utility.flags.flagSO == 1) }"
									(click)="utility.onSort(5)"></i>
							</th>
							<!--<th style="vertical-align:middle;width:140px;" class="bfr-end-col">
				  Group
				  <i style="vertical-align:middle;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagGC == 2),'fa-sort-desc sort-d': (utility.flags.flagGC == 3), 'fa-sort':(utility.flags.flagGC == 1) }" (click)="utility.onSort(4)"></i>
				</th>-->
							<!--<th style="vertical-align:middle;width:160px;" class="bfr-end-col">Display?</th>-->
							<th style="vertical-align:middle;" class="bfr-end-col">Email Address
							</th>
							<th style="vertical-align:middle;width:140px;" class="bfr-end-col">Telephone</th>
							<th style="vertical-align:middle;width:140px;" class="bfr-end-col">Cell Phone</th>
							<th style="vertical-align:middle;" class="bfr-end-col">Alt Email</th>
							<th style="vertical-align:middle;width:140px;" class="bfr-end-col">Alt Cell Phone</th>
						</tr>
					</thead>
					<tbody>
						<tr
							*ngFor="let t of transports  | orderBy: (utility.sortLabels.flagDN==utility.criteria)?utility.criteria:[utility.criteria,utility.sortLabels.flagDN] : utility.direction | paginate: { itemsPerPage:  showNum, currentPage: utility.page };let index = index">
							<td><input type="checkbox" value="{{t.id}}" [ngModel]="selectedIndex === index"
									(change)="CheckedTransport($event,t.id,t,index)"></td>
							<td class="bfr-end-col">{{t.code}}</td>
							<td class="bfr-end-col">{{t.description}}</td>
							<td class="bfr-end-col">{{t.is_active}}</td>
							<td class="bfr-end-col">{{t.sort_order}}</td>
							<!--<td class="text-center bfr-end-col">{{t.group_code}}</td>-->
							<!--<td class="bfr-end-col">{{utility.showDisplayIndicator(t.display_ind)}}</td>-->
							<td class="bfr-end-col">{{t.email}}</td>
							<td class="bfr-end-col">{{t.telephone}}</td>
							<td class="bfr-end-col">{{t.cellphone}}</td>
							<td class="bfr-end-col">{{t.alternative_email}}</td>
							<td class="bfr-end-col">{{t.alternative_cellphone}}</td>
						</tr>
					</tbody>
					<tfoot>
						<tr *ngIf="transports.length > 0" class="pagination_row">
							<td colspan="10">
								<div class="row">
									<div class="col-sm-4">
										<div class="input-group mb-3 rm-brd"
											style="width:125px!important;height:30px!important;">
											<div class="input-group-prepend">
												<label class="input-group-text form-control-sm show-h"
													for="show-id">Show:</label>
											</div>
											<select class="form-control form-control-sm show-h" id="show-id"
												[(ngModel)]="showNum">
												<option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}
												</option>
											</select>
										</div>
									</div>
									<div class="col-sm-8 text-right">
										<pagination-controls (pageChange)="utility.page = $event"></pagination-controls>
									</div>
								</div>
							</td>
						</tr>
						<tr *ngIf="isEmpty">
							<td colspan="4" class="rm-brd">
								<span class="text-info text-small">No transport associations found.</span>
							</td>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
	</div>
</div>